
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/leaky-plumbing",
      function () {
        return require("private-next-pages/services/leaky-plumbing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/leaky-plumbing"])
      });
    }
  